module.exports = __webpack_public_path__ + "media/tier-1-xxxmas-dacc3b58dea6e9a8079be133374c8e8a.mp3";